import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { SupabaseClient } from '../supabase/client';
import type { Locality } from '../types/locality';
import { listActiveLocalities } from '../services/locality.service';

export const localitiesQueryKey = ['localities', 'active'] as const;

export function useLocalities(client: SupabaseClient): UseQueryResult<Locality[]> {
  return useQuery<Locality[]>({
    queryKey: localitiesQueryKey,
    queryFn: () => listActiveLocalities(client),
    staleTime: 24 * 60 * 60 * 1000,
  });
}
